var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 12.0078L6.71875 11.2266C6.875 11.0312 6.875 10.7578 6.67969 10.5625L3.55469 7.51562H17.0312C17.2656 7.51562 17.5 7.32031 17.5 7.04688V5.95312C17.5 5.71875 17.2656 5.48438 17.0312 5.48438H3.55469L6.67969 2.47656C6.875 2.28125 6.875 2.00781 6.71875 1.8125L5.9375 1.03125C5.74219 0.875 5.46875 0.875 5.27344 1.03125L0.117188 6.1875C-0.0390625 6.38281 -0.0390625 6.65625 0.117188 6.85156L5.27344 12.0078C5.46875 12.1641 5.74219 12.1641 5.9375 12.0078Z",
    fill: "#FF1493"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.f7775880.svg";
export { ForwardRef as ReactComponent };